module.exports = __webpack_public_path__ + "img/hacienda_chiapas.a363ba7c.png";